// import axios from "÷axios"
import axios from "../../../constants/axios"
import { navigate } from "gatsby"

import endpoints from "../../../constants/endpoints"

import { formatDateToBackend } from "../../../utils/format-date-time"
import { getAndSetNavigable } from "../../../utils/checkNavigable"

export const CANDIDATE_PROFESSIONAL_FORM_SUBMIT = async (
  formData,
  setProcessing,
  setErrors,
  isContinue,
  dispatch
) => {
  try {
    const skills = []
    formData.skills.map(skill => skills.push(skill.id))
    const res = await axios.post(
      process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_SKILLS_SUBMIT,
      skills
    )
    const response = await axios.post(
      process.env.GATSBY_BASE_URL +
      endpoints.CANDIDATE_PROFESSIONAL_FORM_SUBMIT,
      formData
    )
    if (response.status === 200 && res.status === 200 && isContinue) {
      navigate("/candidate/education")
      setProcessing(false)
    }
    if (response.status === 200 && res.status === 200) {
      getAndSetNavigable(["Education"], dispatch)
    }
    if (response.status === 200 && res.status === 200 && !isContinue) {
      setErrors({ Success: "Data saved successfully." })
      setProcessing(false)
      setTimeout(() => {
        setErrors({})
      }, 2000)
    }
  } catch (error) {
    if (error && error.response && error.response.data) {
      setErrors(error.response.data.errors)
    }
    setProcessing(false)
  }
}

export const CANDIDATE_PROFESSIONAL_DATA_FETCH = async (
  id,
  dispatch,
  setFormState,
  setImages,
  setExperience,
  setCountry
) => {
  try {
    const { data } = await axios.get(
      process.env.GATSBY_BASE_URL +
      endpoints.CANDIDATE_PROFILE_PROFESSIONAL_ROUTE +
      id +
      "/"
    )
    setExperience(data.experience)
    setImages(data.portfolio)
    setCountry(data.personal.country)
    const value = {
      position: data.professional.position,
      industry: data.professional.industry,
      status: data.professional.status,
      salary: data.professional.salary,
      job_type_id: data.professional.job_type_id,
      job_type: data.professional.job_type_id,
      job_shift_id: data.professional.job_shift_id,
      job_shift: data.professional.job_shift_id,
    }
    const res = await axios.get(
      process.env.GATSBY_BASE_URL +
      endpoints.CONFIG_INDUSTRY_DATA_FETCH +
      data.professional.industry +
      "/"
    )
    let skills = []
    if (res.data && res.data.skills && data.skills[0].skill) {
      const industry_skills = res.data.skills
      const skill_set = data.skills[0].skill
      for (let index of skill_set) {
        const skill = industry_skills.filter(industry => industry.id === index)
        if (skill.length > 0) {
          skills.push(skill[0])
        }
      }
    }
    setFormState({
      ...value,
      skills,
      industry_skills:
        res && res.data && res.data.skills ? res.data.skills : [],
    })
    return null
  } catch (err) {
    // dispatch({ type: "LOGOUT" })
  }
}

export const UPDATE_INDUSTRY_SKILLS = async (
  value,
  formState,
  setFormState
) => {
  try {
    const { data } = await axios.get(
      `${process.env.GATSBY_BASE_URL + endpoints.CONFIG_INDUSTRY_DATA_FETCH}${value?.id
      }/`
    )
    setFormState({
      ...formState,
      industry: value?.id,
      industry_skills: data.skills ?? [],
      skills: [],
    })
  } catch (error) {
    setFormState({ ...formState, industry: value, industry_skills: [] })
  }
}

export const PORTFOLIO_FORM_SUBMIT = async (
  portfolioFormData,
  setError,
  id,
  setAddPortfolio,
  image_field,
  setIsLoading
) => {
  const fd = new FormData()
  fd.append("title", portfolioFormData.title)
  // fd.append("description", portfolioFormData.description)
  fd.append("reference", portfolioFormData.description)
  // fd.append("project_url", portfolioFormData.url)
  fd.append("candidate_id", id)
  if (portfolioFormData.url !== null) {
    fd.append("project_url", portfolioFormData.url)
  }
  if (portfolioFormData.description !== null) {
    fd.append("description", portfolioFormData.description)
  }
  if (image_field !== undefined) {
    fd.append("image", image_field, image_field.name)
  }

  try {
    if (portfolioFormData.type === "PATCH") {
      await axios.patch(
        process.env.GATSBY_BASE_URL +
        endpoints.CANDIDATE_PORTFOLIO_SUBMIT +
        portfolioFormData.id +
        `/`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    } else {
      await axios.post(
        process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_PORTFOLIO_SUBMIT,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    }
    setIsLoading(false)
    setAddPortfolio(false)
  } catch (error) {
    setError(error.response.data)
    setIsLoading(false)
  }
}

export const PAST_EXPERIENCE_FORM_SUBMIT = async (
  id,
  setAddPastExp,
  experienceFormData,
  setError,
  setIsLoading
) => {
  const fd = new FormData()
  fd.append("company", experienceFormData.companyName)
  fd.append("position", experienceFormData.position)
  fd.append("description", experienceFormData.description || "")
  fd.append("email", experienceFormData.email)
  fd.append("phone", experienceFormData.phone)
  if (experienceFormData.from) {
    fd.append("started_on", formatDateToBackend(experienceFormData.from))
  }
  if (!experienceFormData.running && experienceFormData.to) {
    fd.append("ended_on", formatDateToBackend(experienceFormData.to))
  }
  fd.append("candidate_id", id)

  try {
    if (experienceFormData.type === "PATCH") {
      await axios.patch(
        process.env.GATSBY_BASE_URL +
        endpoints.CANDIDATE_EXPERIENCE_SUBMIT +
        `${experienceFormData.id}/`,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    } else {
      await axios.post(
        process.env.GATSBY_BASE_URL + endpoints.CANDIDATE_EXPERIENCE_SUBMIT,
        fd,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
    }
    setIsLoading(false)
    setAddPastExp(false)
  } catch (error) {
    setError(error.response.data)
    setIsLoading(false)
  }
}

export const PORTFOLIO_FORM_DELETE = async (id, setShowDeleteForm) => {
  try {
    await axios.delete(
      process.env.GATSBY_BASE_URL +
      endpoints.CANDIDATE_PORTFOLIO_SUBMIT +
      id +
      "/"
    )
    setShowDeleteForm(false)
  } catch (err) { }
}

export const EXPERIENCE_FORM_DELETE = async (id, setShowDeleteForm) => {
  try {
    await axios.delete(
      process.env.GATSBY_BASE_URL +
      endpoints.CANDIDATE_EXPERIENCE_SUBMIT +
      id +
      "/"
    )
    setShowDeleteForm(false)
  } catch (err) { }
}
